module.exports = __webpack_public_path__ + "assets/img/travel-day19.07da04b7.png";